import { Link } from "react-router-dom";
import RegionModal from "./RegionModal";
import { linkHelper } from "../../helper/LinkHelper";
import { MAILING_URL } from "../../constants/APIEndpointConstants";
import { HTMLParserHelper } from "../../helper/HTMLParserHelper";
import React, { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { COUNTRY_LIST_URL } from "../../constants/APIEndpointConstants";
import { fetchCountry } from "../../redux/actions/countryActions";
import Cookies from "js-cookie";
const Footer = ({ data }) => {
  const emailRef = useRef();
  const dispatch = useDispatch();
  const [isScript, setIsScript] = useState(false);
  const [modal, setModal] = useState(false);
  const [country, setCountry] = useState(
    Cookies.getJSON("geolocation")?.country_name
  );
  const countryList = useSelector((state) => state.countryList);
  const {
    copyright_content,
    country_content,
    footer_logo,
    items: itemsB,
  } = data?.footer?.["footer-bottom-menu"]?.menu;
  const { footer_heading_text, items: itemsR } =
    data?.footer?.["footer-resources-menu"]?.menu;
  const { items: itemsS } = data?.footer?.["footer-social-links"]?.menu;
  const handleJoinMailingList = () => {
    const email = emailRef.current;
    if (email.value === "") {
      alert("Enter your email address");
      email.focus();
    } else {
      if (!email.value.match(/\S+@\S+\.\S+/)) {
        alert("Enter valid email address");
        email.focus();
      } else {
        window.location.href = MAILING_URL;
      }
    }
  };
  const handleRegionModal = () => {
    dispatch(fetchCountry(COUNTRY_LIST_URL));
    setModal(true);
  };
  const cookiePreferences = (e) => {
    if (!isScript) {
      e.preventDefault();
      var ostring = `Osano.cm.showDrawer('osano-cm-dom-info-dialog-open');`;
      var script = document.createElement("script");
      script.innerHTML = ostring;
      document.body.appendChild(script);
      setIsScript(true);
    }
  };
  return (
    <>
      <div className="container-fluid footer_container">
        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <div className="container news_padding">
              <div className="row footer_hr">
                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                  <div className="row resource_connects">
                    <p>{footer_heading_text}</p>
                    {itemsR?.map((item) => (
                      <div
                        key={item.ID}
                        className="col-xs-6 col-sm-6 col-md-6 col-lg-6 fmenus"
                        style={{
                          backgroundImage: `url(${item.icon})`,
                          backgroundPosition: "10px 20px",
                          backgroundRepeat: "no-repeat",
                        }}
                      >
                        {linkHelper(item)}
                      </div>
                    ))}
                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 region_container">
                      <p className="region">Change Region</p>
                      <div
                        className="select_region"
                        data-toggle="modal"
                        data-target="#myModal"
                      >
                        <span
                          className="change_region_box"
                          onClick={handleRegionModal}
                        >
                          {country}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 resource_connects stay_connect">
                  <div className="row">
                    <p className="label_join_list" style={{ float: "left" }}>
                      {global?.join_mailing_list}
                    </p>

                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 join-mail hidden-xs"></div>

                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 subscribe_box">
                      <div className="input-group">
                        <form
                          style={{ margin: "0px", padding: "0px" }}
                          id="subscribe_frm"
                        >
                          <input
                            type="text"
                            placeholder="Your email address"
                            id="email_address2"
                            autoComplete="off"
                            name="subscribe_email"
                            className="form-control"
                            ref={emailRef}
                          />
                          <span className="input-group-btn">
                            <button
                              type="button"
                              className="btn btn-secondary subscribe_join"
                              onClick={handleJoinMailingList}
                            >
                              join
                            </button>
                          </span>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 social_media_container polity_footer">
                  <div className="polity_img_footer">
                    <Link to="/">
                      <img
                        className="img-responsive"
                        alt=""
                        src={footer_logo}
                      />
                    </Link>
                  </div>
                  {HTMLParserHelper(country_content)}
                </div>

                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 social_media_container1 breadcrumb_right">
                  <ol className="breadcrumb pull-right clear terms_policy">
                    {itemsB?.slice(0, 4).map((item) => (
                      <li key={item.ID}>{linkHelper(item)}</li>
                    ))}
                  </ol>
                  <ol className="breadcrumb pull-right clear terms_policy">
                    {itemsB?.slice(4).map((item) =>
                      item.title === "Cookie Preferences" ? (
                        <li
                          key={item.ID}
                          onClick={() =>
                            (document.documentElement.scrollTop = 0)
                          }
                        >
                          <a href={item.url} onClick={cookiePreferences}>
                            {item.title}
                          </a>
                        </li>
                      ) : (
                        <li
                          key={item.ID}
                          onClick={() =>
                            (document.documentElement.scrollTop = 0)
                          }
                        >
                          {linkHelper(item)}
                        </li>
                      )
                    )}
                  </ol>
                </div>
              </div>

              <div className="row">
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                  <div className="social_icons">
                    <section id="text-2" className="widget widget_text">
                      <div className="textwidget">
                        {itemsS?.map((item) => (
                          <div className="sicons" key={item.ID}>
                            {linkHelper({
                              ...item,
                              title: <img title="" alt="" src={item.icon} />,
                            })}
                          </div>
                        ))}
                      </div>
                    </section>{" "}
                  </div>
                  <div className="copy_text">{copyright_content}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {modal ? (
        <RegionModal
          countryList={countryList}
          setCountry={setCountry}
          setModal={setModal}
        />
      ) : null}
    </>
  );
};

export default Footer;
